import { ArrowCircleDown } from '../shared/icons';
import { Link } from 'react-router-dom';
import './news-item.css';
import { NEWS_FALLBACK_BANNER } from '../shared/assets';


export default ({data}) => {

  return <Link className="news-item-link" to={`/news/${data.id}`}>
  <article className="news-item">
    <div className="image-wrapper">
      <img src={data.bannerImage ? data.bannerImage : NEWS_FALLBACK_BANNER} width="50px"/>
      <span className="published-badge">{prettifyISODate(data.datePosted)}</span>
      { data.attachments && <span className="download-icon"><ArrowCircleDown /></span>}
    </div>
    <h3>{data.heading}</h3>
    <p> {ellipsiseLongString(data.subHeading)}</p>
  </article>
  </Link>
}

const prettifyISODate = (str) => {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const dateObj = new Date(Date.parse(str));
  const year = dateObj.getFullYear();
  const monthName = monthNames[dateObj.getMonth()];
  const dateOfMonth = dateObj.getDate();
  return `${dateOfMonth} ${monthName} ${year}`;

}

const ellipsiseLongString = (str) => {
    const maxLen = 150;
    if (str.length < maxLen) {
        return str;
    }

    return `${str.substring(0,100)}...`;
}